import { z } from 'zod'

export const TranscriptChunkProcessingStartedSchema = z.object({
	type: z.literal('transcript/chunk-processing-started'),
	chunk: z.string(),
	timestamp: z.number(),
})

export type TranscriptChunkProcessingStarted = z.infer<
	typeof TranscriptChunkProcessingStartedSchema
>
// TODO: Use zod discriminated union
// https://zod.dev/?id=discriminated-unions
export const TranscriptChunkProcessingCompletedSchema = z.object({
	type: z.literal('transcript/chunk-processing-completed'),
	chunk: z.string(),
	timestamp: z.number(),
	analysis: z.string(),
	similarities: z.array(z.string()),
})

export type TranscriptChunkProcessingCompleted = z.infer<
	typeof TranscriptChunkProcessingCompletedSchema
>

export const TargetLiveEventUnion = z.discriminatedUnion('type', [
	TranscriptChunkProcessingStartedSchema,
	TranscriptChunkProcessingCompletedSchema,
])

export type TargetLiveEvent = z.infer<typeof TargetLiveEventUnion>
